import attentive from './attentive';
import pinterest from './pinterest';
import klaviyo from './klaviyo';
import enquirelabs from './enquireLabs';
import social from './social';
import recharge from './recharge';
import mountain from './mountain';
import criteo from './criteo';
import stripe from './stripe';
import kno from './kno';
import tiktok from './tiktok';
import googleAds from './googleAds';
import snapchat from './snapchat';
import facebook from './facebook';
import benchmarks from './benchmarks';
import newBenchmarks from './benchmarks-new';
import influencers from './influencers';
import amazon from './amazon';
import forecasting from './forecasting';
import generalServiceSelector from '../generalServiceSelector';
import twitter from './twitter';
import bing from './bing';
import shipstation from './shipstation';
import shipbob from './shipbob';
import smsbump from './smsbump';
import postscript from './postscript';

const SELECTORS = {
  ...attentive.SELECTORS,
  ...pinterest.SELECTORS,
  ...klaviyo.SELECTORS,
  ...recharge.SELECTORS,
  ...mountain.SELECTORS,
  ...criteo.SELECTORS,
  ...stripe.SELECTORS,
  ...social.SELECTORS,
  ...enquirelabs.SELECTORS,
  ...kno.SELECTORS,
  ...tiktok.SELECTORS,
  ...googleAds.SELECTORS,
  ...snapchat.SELECTORS,
  ...facebook.SELECTORS,
  ...benchmarks.SELECTORS,
  ...newBenchmarks.SELECTORS,
  ...influencers.SELECTORS,
  ...amazon.SELECTORS,
  ...forecasting.SELECTORS,
  ...twitter.SELECTORS,
  ...bing.SELECTORS,
  ...generalServiceSelector.SELECTORS,
  ...shipstation.SELECTORS,
  ...shipbob.SELECTORS,
  ...smsbump.SELECTORS,
  ...postscript.SELECTORS,
};

export default {
  PROPS_TO_SELECTORS: {
    ...attentive.PROPS_TO_SELECTORS,
    ...pinterest.PROPS_TO_SELECTORS,
    ...klaviyo.PROPS_TO_SELECTORS,
    ...recharge.PROPS_TO_SELECTORS,
    ...mountain.PROPS_TO_SELECTORS,
    ...criteo.PROPS_TO_SELECTORS,
    ...stripe.PROPS_TO_SELECTORS,
    ...social.PROPS_TO_SELECTORS,
    ...enquirelabs.PROPS_TO_SELECTORS,
    ...kno.PROPS_TO_SELECTORS,
    ...tiktok.PROPS_TO_SELECTORS,
    ...googleAds.PROPS_TO_SELECTORS,
    ...snapchat.PROPS_TO_SELECTORS,
    ...facebook.PROPS_TO_SELECTORS,
    ...benchmarks.PROPS_TO_SELECTORS,
    ...newBenchmarks.PROPS_TO_SELECTORS,
    ...amazon.PROPS_TO_SELECTORS,
    ...twitter.PROPS_TO_SELECTORS,
    ...bing.PROPS_TO_SELECTORS,
    ...shipstation.PROPS_TO_SELECTORS,
    ...shipbob.PROPS_TO_SELECTORS,
    ...smsbump.PROPS_TO_SELECTORS,
    ...postscript.PROPS_TO_SELECTORS,
  },
  SELECTORS,
  ...SELECTORS,
};
